import { Box, Button, ButtonVariants, FormControlSizes, HStack, type Quote, Text } from '@talos/kyoko';
import { useCallback } from 'react';
import { rfqSliceActions } from '../../../../components/OMS/NewRFQ/RFQSlice';
import { openView } from '../../../../components/OMS/OMSSlice';
import { OMSView } from '../../../../components/OMS/OMSView';
import { QuoteCountdown } from '../../../../components/SummaryCard';
import { useAppStateDispatch } from '../../../../providers/AppStateProvider';

interface BottomActionBarProps {
  quote: Quote | undefined;
}

export const BottomActionBar = ({ quote }: BottomActionBarProps) => {
  const dispatch = useAppStateDispatch();
  const onOpenInRFQDrawer = useCallback(() => {
    if (!quote) {
      return; // typing
    }
    dispatch(openView(OMSView.RFQForm));
    dispatch(rfqSliceActions.showRFQ(quote));
  }, [dispatch, quote]);

  const openInRFQDrawerDisabled = quote == null || !quote.canOpenQuote;

  return (
    <HStack
      flex="0"
      justifyContent="space-between"
      gap="spacing8"
      background="colors.gray.020"
      p="spacing8"
      borderTop="1px solid var(--backgroundDivider)"
    >
      {/* Left side */}
      <Box>
        {quote?.EndTime && (
          <>
            <Text>Ends in </Text>
            <QuoteCountdown status={quote.QuoteStatus} endTime={quote.EndTime} />
          </>
        )}
      </Box>

      {/* Right side */}
      <Button
        size={FormControlSizes.Small}
        variant={ButtonVariants.Primary}
        disabled={openInRFQDrawerDisabled}
        onClick={onOpenInRFQDrawer}
        data-testid="open-in-quotes-drawer-button"
      >
        Open in RFQ drawer
      </Button>
    </HStack>
  );
};
